const textProps = {
  copyright: {
    href: "#",
    target: "_blank",
    children: "Copyright © " + new Date().getFullYear() + " AG+ Energies Admin",
  },
};
export default textProps;
